import React from 'react';
import './Description.css';

const Description = props => {
  const docsLink =
    'https://docs.servicenow.com/bundle/newyork-application-development/page/build/applications/task/t_PublishApplicationsToAnUpdateSet.html';

  return (
    <p className="addedText">
      To clone an application,{' '}
      <a href={docsLink} target="_blank" rel="noopener noreferrer">
        export it to an update set
      </a>
      , and upload the resulting .xml file here.
    </p>
  );
};

export default Description;
